import { FormTextField } from '../../../../../../design-system/form-text-field/form-text-field';
import { Inline } from '../../../../../../design-system/inline/inline';
import { Stack } from '../../../../../../design-system/stack/stack';

export const AdditionalInformation = () => {
  return (
    <Stack space={4} className="w-full">
      <h2 className="text-seapoint-gray-900 text-lg font-semibold">
        Additional Information
        <span className="text-sm text-seapoint-gray-text"> (Optional)</span>
      </h2>

      <div className="w-full">
        <FormTextField label="Role" inputName="role" placeholder="Enter role" isOptional={true} />
      </div>

      <div className="w-full">
        <FormTextField
          label="Address Line 1"
          inputName="addressLine1"
          placeholder="Enter address line 1"
          isOptional={true}
        />
      </div>

      <div className="w-full">
        <FormTextField
          label="Address Line 2"
          inputName="addressLine2"
          placeholder="Enter address line 2"
          isOptional={true}
        />
      </div>

      <div className="w-full">
        <FormTextField label="Town/City" inputName="townCity" placeholder="Enter town or city" isOptional={true} />
      </div>

      <Inline space={4} className="w-full justify-between" wrap="nowrap">
        <div className="w-1/2">
          <FormTextField
            label="County/District"
            inputName="countyDistrict"
            placeholder="Enter county or district"
            isOptional={true}
          />
        </div>
        <div className="w-1/2">
          <FormTextField label="Postcode" inputName="postcode" placeholder="Enter postcode" isOptional={true} />
        </div>
      </Inline>
    </Stack>
  );
};
